export default __webpack_public_path__ + "static/media/test.a4d9d3b0.png";